import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=ed94b8c8&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"
import style0 from "./payment.vue?vue&type=style&index=0&id=ed94b8c8&prod&lang=scss&scoped=true"
import style1 from "./payment.vue?vue&type=style&index=1&id=ed94b8c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed94b8c8",
  null
  
)

export default component.exports